import portalKit from '@portal/kit'

// locales are downloaded from phraseapp with yarn get-locales
import de from './de.json'
import fr from './fr.json'
import en from './en.json'
import es from './es.json'
import nl from './nl.json'
import zh from './zh.json'

export default portalKit.initI18n({
  fr: { translation: fr },
  en: { translation: en },
  de: { translation: de },
  es: { translation: es },
  nl: { translation: nl },
  zh: { translation: zh },
})
